import { OptionType } from 'components/shared/form/Autocomplete/Autocomplete.types';
import React from 'react';
import { ValueContainerProps } from 'react-select';

export function ValueContainer(props: ValueContainerProps<OptionType, boolean>) {
  return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>;
}
